<mat-card class="gs-trends">
  <h5 class="text-muted">Trending Now</h5>
  <hr>
  <anms-full-trends></anms-full-trends>
</mat-card>

<!--<div class="gs-trending">-->
<!--    <mat-accordion>-->
<!--        <mat-expansion-panel>-->
<!--            <mat-expansion-panel-header>-->
<!--                <mat-panel-title>-->
<!--                    #ArrestKimosh-->
<!--                </mat-panel-title>-->
<!--                <mat-panel-description>-->
<!--                    3k Scribes-->
<!--                </mat-panel-description>-->
<!--            </mat-expansion-panel-header>-->
<!--            <p>A list of top 3 scribes on this hashtag</p>-->
<!--            <button mat-button color="primary">-->
<!--                View More-->
<!--                <mat-icon>read_more</mat-icon>-->
<!--            </button>-->
<!--        </mat-expansion-panel>-->
<!--        <mat-expansion-panel>-->
<!--            <mat-expansion-panel-header>-->
<!--                <mat-panel-title>-->
<!--                    #FeedbackDay-->
<!--                </mat-panel-title>-->
<!--                <mat-panel-description>-->
<!--                    14 Scribes-->
<!--                </mat-panel-description>-->
<!--            </mat-expansion-panel-header>-->
<!--            <p>A list of top 3 scribes on this hashtag</p>-->
<!--            <button mat-button color="primary">-->
<!--                View More-->
<!--                <mat-icon>read_more</mat-icon>-->
<!--            </button>-->
<!--        </mat-expansion-panel>-->
<!--        <mat-expansion-panel>-->
<!--            <mat-expansion-panel-header>-->
<!--                <mat-panel-title>-->
<!--                    #2Bonge-->
<!--                </mat-panel-title>-->
<!--                <mat-panel-description>-->
<!--                    4k Scribes-->
<!--                </mat-panel-description>-->
<!--            </mat-expansion-panel-header>-->
<!--            <p>A list of top 3 scribes on this hashtag</p>-->
<!--            <button mat-button color="primary">-->
<!--                View More-->
<!--                <mat-icon>read_more</mat-icon>-->
<!--            </button>-->
<!--        </mat-expansion-panel>-->
<!--        <mat-expansion-panel>-->
<!--            <mat-expansion-panel-header>-->
<!--                <mat-panel-title>-->
<!--                    #GScroll-->
<!--                </mat-panel-title>-->
<!--                <mat-panel-description>-->
<!--                    700 Scribes-->
<!--                </mat-panel-description>-->
<!--            </mat-expansion-panel-header>-->
<!--            <p>A list of top 3 scribes on this hashtag</p>-->
<!--            <button mat-button color="primary">-->
<!--                View More-->
<!--                <mat-icon>read_more</mat-icon>-->
<!--            </button>-->
<!--        </mat-expansion-panel>-->
<!--        <mat-expansion-panel>-->
<!--            <mat-expansion-panel-header>-->
<!--                <mat-panel-title>-->
<!--                    #Scribe-->
<!--                </mat-panel-title>-->
<!--                <mat-panel-description>-->
<!--                    800 Scribes-->
<!--                </mat-panel-description>-->
<!--            </mat-expansion-panel-header>-->
<!--            <p>A list of top 3 scribes on this hashtag</p>-->
<!--            <button mat-button color="primary">-->
<!--                View More-->
<!--                <mat-icon>read_more</mat-icon>-->
<!--            </button>-->
<!--        </mat-expansion-panel>-->
<!--        <mat-expansion-panel>-->
<!--            <mat-expansion-panel-header>-->
<!--                <mat-panel-title>-->
<!--                    #FeedbackDay-->
<!--                </mat-panel-title>-->
<!--                <mat-panel-description>-->
<!--                    300 Scribes-->
<!--                </mat-panel-description>-->
<!--            </mat-expansion-panel-header>-->
<!--            <p>A list of top 3 scribes on this hashtag</p>-->
<!--            <button mat-button color="primary">-->
<!--                View More-->
<!--                <mat-icon>read_more</mat-icon>-->
<!--            </button>-->
<!--        </mat-expansion-panel>-->
<!--    </mat-accordion>-->
<!--</div>-->
